export const LoginDialog = {
	selectors: {
		toggles: [...document.querySelectorAll(".js-login-dialog--toggle")],
		dialog: document.querySelector(".js-login-dialog--dialog"),
	},

	init() {
		if (!this.selectors.toggles) {
			return;
		}

		this.onToggleClick = this.onToggleClick.bind(this);
		this.onAwayClick = this.onAwayClick.bind(this);

		this.selectors.toggles.forEach((toggle) => {
			toggle.addEventListener("click", this.onToggleClick);
		});
		document.addEventListener("click", this.onAwayClick);
	},

	onToggleClick(event) {
		event.preventDefault();

		this.toggle();
	},

	onAwayClick(event) {
		const isActive = this.selectors.dialog.classList.contains("is-active");

		if (!isActive) {
			return;
		}

		const isAway =
			!event.target.closest(".js-login-dialog--toggle") &&
			!event.target.closest(".js-login-dialog--dialog") &&
			!event.target.closest(
				".c-tk-header__button:not(.c-tk-header__button--menu-close)"
			);

		if (isAway) {
			this.toggle(false);
		}
	},

	toggle(state) {
		this.selectors.dialog.classList.toggle("is-active", state);
	},
};

LoginDialog.init();
